import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsModel } from "../models/alerts";
import { AlertsJurisdictionsView } from "./alerts-jurisdictions";
import { AlertsCourtsView } from "./alerts-courts";
import { AlertsSearchesView } from "./alerts-searches";
import { AlertsReportsView } from "./alerts-reports";
import * as BootstrapDialog from "bootstrap3-dialog";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

const template = require<string>("./alerts.html");

const dom = {
    SECTION_LINKS: ".alert-section-link",
    ALERT_REGION: "#alert-region",
    ALERT_HEADER_EMAIL_EXAMPLE: "#alert-header-email-example",
    MAIL_LINK: "#mail-link"
};

@backboneViewProperties({
    template: template,
    tagName: "div",
})
export class AlertsView extends Marionette.LayoutView<any> {

    private alertsRegion: Marionette.Region;

    constructor(private subsection: string, private user: AppUser, public model: AlertsModel) {
        super({ model: model });
        this.model.Section = subsection || "searches";
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SECTION_LINKS] = (e) => this.sectionLinkClick(e);
        events["click " + dom.ALERT_HEADER_EMAIL_EXAMPLE] = (e) => this.showExampleEmailClick(e);
        events["click " + dom.MAIL_LINK] = (e) => this.mailLinkClick(e);
        return events;
    }

    public regions() {
        const regions: any = {
            alertsRegion: dom.ALERT_REGION
        };
        return regions;
    }

    public onShow() {
        this.renderSectionView();
        this.listenTo(this.model, "change:Section", this.sectionChanged);
    }

    private sectionLinkClick(e: JQueryEventObject): void {
        e.preventDefault();
        e.stopPropagation();
        const url = $(e.currentTarget).attr("href");
        Backbone.history.navigate(url, {trigger: true});
    }

    private sectionChanged(): void {
        this.renderSectionView();
    }

    private renderSectionView() {
        if (this.alertsRegion.el) {
            this.$(dom.SECTION_LINKS).removeClass("selected").filter(`[href*="${this.model.Section}"]`).addClass("selected");
            switch (this.model.Section) {
                case "jurisdictions":
                    this.alertsRegion.show(new AlertsJurisdictionsView({model: this.model, user: this.user}));
                    break;
                case "courts":
                    this.alertsRegion.show(new AlertsCourtsView({model: this.model, user: this.user}));
                    break;
                case "searches":
                    this.alertsRegion.show(new AlertsSearchesView({model: this.model, user: this.user}));
                    break;
                case "reports":
                    this.alertsRegion.show(new AlertsReportsView({model: this.model, user: this.user}));
                    break;
                default:
                    break;
            }
        }
    }

    private showExampleEmailClick(e: JQueryEventObject) {
        BootstrapDialog.show({
            title: "Example Email",
            message: $('<img src="/assets/images/alerts-email-screenshot.png">'),
            cssClass: "alert-modal"
        });

        $(".modal-backdrop").click(() => {
            $(".alert-modal").modal("hide");
        });
    }

    private mailLinkClick(e: JQueryEventObject) {
        e.preventDefault();
        e.stopPropagation();

        const mailUrl = $(e.currentTarget).attr("href");
        window.open(mailUrl);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts.ts